/* eslint-disable @typescript-eslint/camelcase */
/**
 * Queries external service DQE for suggested addresss
 */
import api from "./api";
import debug from "./debug";

const COUNTRIES_NUMBER_LAST = [
  "AUT",
  "DNK",
  "DEU",
  "ITA",
  "JPN",
  "KOR",
  "MEX",
  "ESP"
];
const BRAZIL_DQE_CODE = "BRA";
const LENGHT_NUMBER_TO_FORMAT_BRAZIL_ADDREESS2 = 5;
export interface DqeAddress {
  IDLocalite: string; // id?
  label: string; // label
  Voie: string; // street
  Numero: string; // number
  Localite: string; //city
  Region2: string; // big city (in japan)
  Province: string; //state
  Pays: string; //country
  CodePostal: string; //postal code
  // Saisie - original search term (?)
}
export interface AddressFormModel {
  [formModelKey: string]: string | null | undefined | boolean;
  streetAddress1: string;
  streetAddress2: string;
  addressLocality: string;
  addressRegion: string;
  postalCode: string;
  addressCountry: string;
}

export async function getPlaces(
  country: string,
  input: string
): Promise<DqeAddress[]> {
  //debug("[utils/dqePlaces] loading places...");
  const receivedPlaces: DqeAddress[] = await api.getPlacesDqe(country, input);
  //debug("[utils/places] receivedPlaces:", receivedPlaces);
  return receivedPlaces;
}
function formatAddress2ForBrazil(place: DqeAddress): string {
  const labalArray = place.label.split("|");
  if (labalArray.length === LENGHT_NUMBER_TO_FORMAT_BRAZIL_ADDREESS2) {
    return labalArray[2].toString();
  }
  return "";
}
function formatAddressForBrazil(place: DqeAddress): string {
  return `${place.Voie ? place.Voie : ""}, ${place.Numero ? place.Numero : ""}`;
}
export function convertPlaceToFormModel(place: DqeAddress): AddressFormModel {
  debug("[dqePlaces] convertPlaceToFormModel: place:", place);

  const formattedAddress1 =
    COUNTRIES_NUMBER_LAST.indexOf(place.Pays) >= 0
      ? place.Voie + " " + place.Numero
      : place.Numero + " " + place.Voie;
  const formModel: AddressFormModel = {
    streetAddress1:
      place && place.Pays === BRAZIL_DQE_CODE
        ? formatAddressForBrazil(place)
        : formattedAddress1.trim(),
    streetAddress2:
      place && place.Pays === BRAZIL_DQE_CODE
        ? formatAddress2ForBrazil(place)
        : "",
    addressLocality: place.Localite,
    addressRegion: place.Province || "",
    postalCode: place.CodePostal || "",
    addressCountry: place.Pays || ""
  };
  return formModel;
}

export function clearDQRForm(place: string): AddressFormModel {
  const clear: AddressFormModel = {
    streetAddress1: "",
    streetAddress2: "",
    addressLocality: "",
    addressRegion: "",
    postalCode: "",
    addressCountry: place
  };
  return clear;
}

function concat(str1: string, str2: string): string {
  const str = (str1 || "") + " " + (str2 || "");
  return str.trim();
}
